export const REQUEST_ERROR = "ERROR";
export const REQUEST_PENDING = "PENDING";
export const REQUEST_SUCCESS = "SUCCESS";

export const REQUEST_LOGIN_ID: string = "REQUEST_LOGIN_ID";
export const REQUEST_RENEW_ID: string = "REQUEST_RENEW_ID";
export const REQUEST_PASSWORD_CHANGE_ID: string = "REQUEST_PASSWORD_CHANGE_ID";
export const REQUEST_LOGOUT_ID: string = "REQUEST_LOGOUT_ID";

export const REQUEST_REGISTRATION_VERIFY_CODE: string = "REQUEST_REGISTRATION_VERIFY_CODE";
export const REQUEST_REGISTRATION_SET_PASSWORD: string = "REQUEST_REGISTRATION_SET_PASSWORD";
export const REQUEST_REGISTRATION_CODE_RESEND: string = "REQUEST_REGISTRATION_CODE_RESEND";

export const REQUEST_CARDS_STATS_ID: string = "REQUEST_CARDS_STATS_ID";
export const REQUEST_CARDS_LIST_ID: string = "REQUEST_CARDS_LIST_ID";
export const REQUEST_CARDS_VIEW_ID: string = "REQUEST_CARDS_VIEW_ID";
export const REQUEST_CARDS_TRANSFER_TO_CRM_ID: string = "REQUEST_CARDS_TRANSFER_TO_CRM_ID";
export const REQUEST_CARDS_LINK_CREATE_ID: string = "REQUEST_CARDS_LINK_CREATE_ID";

export const REQUEST_PRELIMINARY_CREDIT_VIEW_ID: string = "REQUEST_PRELIMINARY_CREDIT_VIEW_ID";
export const REQUEST_PRELIMINARY_CREDIT_NEW_ID: string = "REQUEST_PRELIMINARY_CREDIT_NEW_ID";
export const REQUEST_PRELIMINARY_CREDIT_OPTIONS_ID: string =
  "REQUEST_PRELIMINARY_CREDIT_OPTIONS_ID";
export const REQUEST_PRELIMINARY_CREDIT_UPDATE_MULTIPLE_ID: string =
  "REQUEST_PRELIMINARY_CREDIT_UPDATE_MULTIPLE_ID";
export const REQUEST_PRELIMINARY_CREDIT_DELETE_ID: string = "REQUEST_PRELIMINARY_CREDIT_DELETE_ID";

export const REQUEST_CREDIT_LIST_ID: string = "REQUEST_CREDIT_LIST_ID";
export const REQUEST_CREDIT_VIEW_ID: string = "REQUEST_CREDIT_VIEW_ID";
export const REQUEST_CREDIT_NEW_ID: string = "REQUEST_CREDIT_NEW_ID";
export const REQUEST_CREDIT_PREVIOUS_ID: string = "REQUEST_CREDIT_PREVIOUS_ID";
export const REQUEST_CREDIT_PREVIOUS_ACTIVE_ID: string = "REQUEST_CREDIT_PREVIOUS_ACTIVE_ID";
export const REQUEST_CREDIT_PREVIOUS_LAST_ID: string = "REQUEST_CREDIT_PREVIOUS_LAST_ID";
export const REQUEST_CREDIT_PREVIOUS_VIEW_ID: string = "REQUEST_CREDIT_PREVIOUS_VIEW_ID";
export const REQUEST_CREDIT_OPTIONS_ID: string = "REQUEST_CREDIT_OPTIONS_ID";
export const REQUEST_CREDIT_UPDATE_ID: string = "REQUEST_CREDIT_UPDATE_ID";
export const REQUEST_CREDIT_UPDATE_PROPERTY_ID: string = "REQUEST_CREDIT_UPDATE_PROPERTY_ID";
export const REQUEST_CREDIT_UPDATE_MULTIPLE_PROPERTIES_ID: string =
  "REQUEST_CREDIT_UPDATE_MULTIPLE_PROPERTIES_ID";
export const REQUEST_CREDIT_REQUEST_ID: string = "REQUEST_CREDIT_REQUEST_ID";
export const REQUEST_CREDIT_STATUS_CHANGE_ID: string = "REQUEST_CREDIT_STATUS_CHANGE_ID";
export const REQUEST_CREDIT_AVAILABLE_STATUSES_ID: string = "REQUEST_CREDIT_AVAILABLE_STATUSES_ID_";
export const REQUEST_CREDIT_DOWNLOAD_ID: string = "REQUEST_CREDIT_DOWNLOAD_ID";
export const REQUEST_CREDIT_LOCK_ID: string = "REQUEST_CREDIT_LOCK_ID";
export const REQUEST_CREDIT_UNLOCK_ID: string = "REQUEST_CREDIT_UNLOCK_ID";
export const REQUEST_CREDIT_POSTPONE_INSTALLMENT_ID: string =
  "REQUEST_CREDIT_POSTPONE_INSTALLMENT_ID";
export const REQUEST_CREDIT_ATTACHMENT_LIST_ID: string = "REQUEST_CREDIT_ATTACHMENT_LIST_ID";
export const REQUEST_CREDIT_ATTACHMENT_UPLOAD_ID: string = "REQUEST_CREDIT_ATTACHMENT_UPLOAD_ID";
export const REQUEST_CREDIT_ATTACHMENT_UPDATE_ID: string = "REQUEST_CREDIT_ATTACHMENT_UPDATE_ID";
export const REQUEST_CREDIT_ATTACHMENT_DELETE_ID: string = "REQUEST_CREDIT_ATTACHMENT_DELETE_ID";
export const REQUEST_CREDIT_ATTACHMENT_TYPE_NEW_ID: string =
  "REQUEST_CREDIT_ATTACHMENT_TYPE_NEW_ID";
export const REQUEST_CREDIT_ATTACHMENT_TYPE_REFRESH_ID: string =
  "REQUEST_CREDIT_ATTACHMENT_TYPE_REFRESH_ID";
export const REQUEST_CREDIT_ATTACHMENT_TYPE_DELIVERED_ID: string =
  "REQUEST_CREDIT_ATTACHMENT_TYPE_DELIVERED_ID";
export const REQUEST_CREDIT_PAYMENT_CREATE_ID: string = "REQUEST_CREDIT_PAYMENT_CREATE_ID";
export const REQUEST_CREDIT_PAYMENT_DELETE_ID: string = "REQUEST_CREDIT_PAYMENT_DELETE_ID";
export const REQUEST_CREDIT_LINK_CREATE_ID: string = "REQUEST_CREDIT_LINK_CREATE_ID";

export const REQUEST_BANK_CREDIT_VIEW_ID: string = "REQUEST_BANK_CREDIT_VIEW_ID";
export const REQUEST_BANK_CREDIT_NEW_ID: string = "REQUEST_BANK_CREDIT_NEW_ID";
export const REQUEST_BANK_CREDIT_OPTIONS_ID: string = "REQUEST_BANK_CREDIT_OPTIONS_ID";
export const REQUEST_BANK_CREDIT_UPDATE_MULTIPLE_PROPERTIES_ID: string =
  "REQUEST_BANK_CREDIT_UPDATE_MULTIPLE_PROPERTIES_ID";

export const REQUEST_PROFILES_LIST_ID: string = "REQUEST_PROFILES_LIST_ID";
export const REQUEST_PROFILES_CREATE_ID: string = "REQUEST_PROFILES_CREATE_ID";
export const REQUEST_PROFILES_UPDATE_ID: string = "REQUEST_PROFILES_UPDATE_ID";
export const REQUEST_PROFILES_DELETE_ID: string = "REQUEST_PROFILES_DELETE_ID";
export const REQUEST_PROFILES_PERMISSIONS_ID: string = "REQUEST_PROFILES_PERMISSIONS_ID";
export const REQUEST_PROFILE_AGENT_CREATE_ID: string = "REQUEST_PROFILE_AGENT_CREATE_ID";

export const REQUEST_USER_RECOMMENDATION_STATS_ID: string = "REQUEST_USER_RECOMMENDATION_STATS_ID";
export const REQUEST_USER_RECOMMENDATION_LIST_ID: string = "REQUEST_USER_RECOMMENDATION_LIST_ID";
export const REQUEST_USER_RECOMMENDATION_TRANSFER_TO_CRM_ID: string =
  "REQUEST_USER_RECOMMENDATION_TRANSFER_TO_CRM_ID_";

export const REQUEST_USERS_LIST_ID: string = "REQUEST_USERS_LIST_ID";
export const REQUEST_USERS_CREATE_ID: string = "REQUEST_USERS_CREATE_ID";
export const REQUEST_USERS_UPDATE_ID: string = "REQUEST_USERS_UPDATE_ID";
export const REQUEST_USERS_CLIENTS_ID: string = "REQUEST_USERS_CLIENTS_ID";
export const REQUEST_USERS_CLIENTS_MY_ID: string = "REQUEST_USERS_CLIENTS_MY_ID";
export const REQUEST_USERS_CLIENTS_STATS_ID: string = "REQUEST_USERS_CLIENTS_STATS_ID";
export const REQUEST_USERS_CLIENTS_VIEW_ID: string = "REQUEST_USERS_CLIENTS_VIEW_ID";
export const REQUEST_USERS_CLIENTS_NEW_ID: string = "REQUEST_USERS_CLIENTS_NEW_ID";
export const REQUEST_USERS_CLIENTS_ABSENCE_AVAILABLE_ID: string =
  "REQUEST_USERS_CLIENTS_ABSENCE_AVAILABLE_ID";
export const REQUEST_USERS_CLIENTS_UPDATE_PROPERTY_ID: string =
  "REQUEST_USERS_CLIENTS_UPDATE_PROPERTY_ID";
export const REQUEST_USERS_CLIENTS_DELETE_ID: string = "REQUEST_USERS_CLIENTS_DELETE_ID";
export const REQUEST_USER_CHANGE_LANGUAGE: string = "REQUEST_USER_CHANGE_LANGUAGE";
export const REQUEST_USER_CHANGE_PASSWORD: string = "REQUEST_USER_CHANGE_PASSWORD";
export const REQUEST_USER_CHANGE_AVATAR: string = "REQUEST_USER_CHANGE_AVATAR";
export const REQUEST_USER_COMMENTS_LIST_ID: string = "REQUEST_USER_COMMENTS_LIST_ID";
export const REQUEST_USER_COMMENTS_CREATE_ID: string = "REQUEST_USER_COMMENTS_CREATE_ID";
export const REQUEST_USER_AGENTS_LIST_ID: string = "REQUEST_USER_AGENTS_LIST_ID";
export const REQUEST_USER_AGENT_CHANGE_ID: string = "REQUEST_USER_AGENT_CHANGE_ID";
export const REQUEST_USERS_CLIENTS_BLACKLIST_ID: string = "REQUEST_USERS_CLIENTS_BLACKLIST_ID";
export const REQUEST_USER_UPDATE_PROFILE_ID: string = "REQUEST_USER_UPDATE_PROFILE_ID";
export const REQUEST_USER_ATTACHMENT_UPLOAD_ID: string = "REQUEST_USER_ATTACHMENT_UPLOAD_ID";
export const REQUEST_USER_ATTACHMENT_DELETE_ID: string = "REQUEST_USER_ATTACHMENT_DELETE_ID";
export const REQUEST_USER_ATTACHMENT_LIST_ID: string = "REQUEST_USER_ATTACHMENT_LIST_ID";
export const REQUEST_AGENT_CLIENT_LIMITS_GET_ID: string = "REQUEST_AGENT_CLIENT_LIMITS_GET_ID";
export const REQUEST_AGENT_CLIENT_LIMITS_UPDATE_ID: string = "REQUEST_AGENT_CLIENT_LIMITS_UPDATE_ID";

export const REQUEST_CHATS_LIST_ID: string = "REQUEST_CHATS_LIST_ID";
export const REQUEST_CHATS_ONE_ID: string = "REQUEST_CHATS_ONE_ID";
export const REQUEST_CHATS_MESSAGES_LIST_ID: string = "REQUEST_CHATS_MESSAGES_LIST_ID";
export const REQUEST_CHATS_MESSAGES_READ_ID: string = "REQUEST_CHATS_MESSAGES_READ_ID";
export const REQUEST_CHATS_MESSAGES_CREATE_ID: string = "REQUEST_CHATS_MESSAGES_CREATE_ID";
export const REQUEST_CHATS_MESSAGES_ATTACHMENT_UPLOAD_ID: string =
  "REQUEST_CHATS_MESSAGES_ATTACHMENT_UPLOAD_ID";

export const REQUEST_CONTROL_F1: string = "REQUEST_CONTROL_F1";
export const REQUEST_CONTROL_F2: string = "REQUEST_CONTROL_F2";
export const REQUEST_CONTROL_F3: string = "REQUEST_CONTROL_F3";
export const REQUEST_CONTROL_F4: string = "REQUEST_CONTROL_F4";

export const REQUEST_TODO_LIST_ID: string = "REQUEST_TODO_LIST_ID";
export const REQUEST_TODO_VIEW_ID: string = "REQUEST_TODO_VIEW_ID";
export const REQUEST_TODO_CREATE_ID: string = "REQUEST_TODO_CREATE_ID";
export const REQUEST_TODO_DELETE_ID: string = "REQUEST_TODO_DELETE_ID";
export const REQUEST_TODO_UPDATE_PROPERTY_ID: string = "REQUEST_TODO_UPDATE_PROPERTY_ID";
export const REQUEST_TODO_UPDATE_MULTIPLE_ID: string = "REQUEST_TODO_UPDATE_MULTIPLE_ID";
export const REQUEST_TODO_COMPLETED_ID: string = "REQUEST_TODO_COMPLETED_ID";
export const REQUEST_TODO_UNCOMPLETED_ID: string = "REQUEST_TODO_UNCOMPLETED_ID";
export const REQUEST_TODO_OPTIONS_ID: string = "REQUEST_TODO_OPTIONS_ID";
export const REQUEST_TODO_NUMBER_ID: string = "REQUEST_TODO_NUMBER_ID";
export const REQUEST_TODO_REPLACEMENT_AVAILABLE_ID: string =
  "REQUEST_TODO_REPLACEMENT_AVAILABLE_ID";
export const REQUEST_TUTTI_CLIENTS_ID: string = "REQUEST_TUTTI_CLIENTS_ID";
export const REQUEST_TUTTI_BATCH_UPLOAD_ID: string = "REQUEST_TUTTI_BATCH_UPLOAD_ID";
export const REQUEST_AGENT_DASHBOARD_KPIS_ID: string = "REQUEST_AGENT_DASHBOARD_KPIS_ID";
export const REQUEST_ADMIN_DASHBOARD_KPIS_ID: string = "REQUEST_ADMIN_DASHBOARD_KPIS_ID";
export const REQUEST_ADMIN_DASHBOARD_BANK_STATUS_ID: string =
  "REQUEST_ADMIN_DASHBOARD_BANK_STATUS_ID";
export const REQUEST_ADMIN_DASHBOARD_CONVERSION_HEALTH_ID: string =
  "REQUEST_ADMIN_DASHBOARD_CONVERSION_HEALTH_ID";
export const REQUEST_ADMIN_DASHBOARD_DELAYED_PROCESSING_ALARM_COUNT_ID: string =
  "REQUEST_ADMIN_DASHBOARD_DELAYED_PROCESSING_ALARM_COUNT_ID";
export const REQUEST_ADMIN_DASHBOARD_DELAYED_PROCESSING_ALARM_INFO_ID: string =
  "REQUEST_ADMIN_DASHBOARD_DELAYED_PROCESSING_ALARM_INFO_ID";
export const REQUEST_ADMIN_DASHBOARD_MONTHLY_PROGRESS_ID: string =
  "REQUEST_ADMIN_DASHBOARD_MONTHLY_PROGRESS_ID";
export const REQUEST_ADMIN_DASHBOARD_YEARLY_PROGRESS_ID: string =
  "REQUEST_ADMIN_DASHBOARD_YEARLY_PROGRESS_ID";
export const REQUEST_ADMIN_DASHBOARD_AGENTS_ID: string = "REQUEST_ADMIN_DASHBOARD_AGENTS_ID";
export const REQUEST_TEAM_LEAD_DASHBOARD_DAILY_STATE_ID: string =
  "REQUEST_TEAM_LEAD_DASHBOARD_DAILY_STATE_ID";
export const REQUEST_TEAM_LEAD_DASHBOARD_DAILY_STATE_ITEMS_ID: string =
  "REQUEST_TEAM_LEAD_DASHBOARD_DAILY_STATE_ITEMS_ID";
export const REQUEST_TEAM_LEAD_DASHBOARD_DAILY_KPIS_ID: string =
  "REQUEST_TEAM_LEAD_DASHBOARD_DAILY_KPIS_ID";
export const REQUEST_TEAM_LEAD_DASHBOARD_CALENDAR_ID: string =
  "REQUEST_TEAM_LEAD_DASHBOARD_CALENDAR_ID";
export const REQUEST_AGENT_DASHBOARD_CALENDAR_ID: string =
  "REQUEST_AGENT_DASHBOARD_CALENDAR_ID";
export const REQUEST_AGENT_DASHBOARD_NEXT_ID: string = "REQUEST_AGENT_DASHBOARD_NEXT_ID";
export const REQUEST_AGENT_DASHBOARD_SEARCH_ID: string = "REQUEST_AGENT_DASHBOARD_SEARCH_ID";
export const REQUEST_AGENT_DASHBOARD_CLIENT_TOGGLE_ID: string =
  "REQUEST_AGENT_DASHBOARD_CLIENT_TOGGLE_ID";
export const REQUEST_AGENT_DASHBOARD_CALL_OUTCOME_ID: string =
  "REQUEST_AGENT_DASHBOARD_CALL_OUTCOME_ID";
export const REQUEST_AGENT_DASHBOARD_SCHEDULED_CALLS_ID: string =
  "REQUEST_AGENT_DASHBOARD_SCHEDULED_CALLS_ID";
export const REQUEST_AGENT_DASHBOARD_AGENT_OPTIONS_ID: string =
  "REQUEST_AGENT_DASHBOARD_AGENT_OPTIONS_ID";
export const REQUEST_AGENT_DASHBOARD_CANCEL_TODO_ID: string =
  "REQUEST_AGENT_DASHBOARD_CANCEL_TODO_ID";
export const REQUEST_TARGETS_GET_ID: string = "REQUEST_TARGETS_GET_ID";
export const REQUEST_TARGETS_SAVE_ID: string = "REQUEST_TARGETS_SAVE_ID_";
export const REQUEST_TARGETS_OPTIONS_GET_ID: string = "REQUEST_TARGETS_OPTIONS_GET_ID";
export const REQUEST_MOTIVATIONAL_MESSAGES_LIST_ID: string =
  "REQUEST_MOTIVATIONAL_MESSAGES_LIST_ID";
export const REQUEST_MOTIVATIONAL_MESSAGE_CURRENT_ID: string =
  "REQUEST_MOTIVATIONAL_MESSAGE_CURRENT_ID";
export const REQUEST_MOTIVATIONAL_MESSAGE_VIEW_ID: string = "REQUEST_MOTIVATIONAL_MESSAGE_VIEW_ID_";
export const REQUEST_MOTIVATIONAL_MESSAGE_CREATE_ID: string =
  "REQUEST_MOTIVATIONAL_MESSAGE_CREATE_ID";
export const REQUEST_MOTIVATIONAL_MESSAGE_UPDATE_ID: string =
  "REQUEST_MOTIVATIONAL_MESSAGE_UPDATE_ID_";
export const REQUEST_MOTIVATIONAL_MESSAGE_DELETE_ID: string =
  "REQUEST_MOTIVATIONAL_MESSAGE_DELETE_ID_";
export const REQUEST_MOTIVATIONAL_MESSAGE_ACTIVATE_ID: string =
  "REQUEST_MOTIVATIONAL_MESSAGE_ACTIVATE_ID_";

export const REQUEST_ABSENCE_LIST_ID: string = "REQUEST_ABSENCE_LIST_ID";
export const REQUEST_ABSENCE_VIEW_ID: string = "REQUEST_ABSENCE_VIEW_ID";
export const REQUEST_ABSENCE_CREATE_ID: string = "REQUEST_ABSENCE_CREATE_ID";
export const REQUEST_ABSENCE_UPDATE_ID: string = "REQUEST_ABSENCE_UPDATE_ID";
export const REQUEST_ABSENCE_DELETE_ID: string = "REQUEST_ABSENCE_DELETE_ID";
export const REQUEST_ABSENCE_APPROVE_ID: string = "REQUEST_ABSENCE_APPROVE_ID";
export const REQUEST_ABSENCE_REJECT_ID: string = "REQUEST_ABSENCE_REJECT_ID";
export const REQUEST_ABSENCE_CANCEL_ID: string = "REQUEST_ABSENCE_CANCEL_ID";
export const REQUEST_ABSENCE_OPTIONS_ID: string = "REQUEST_ABSENCE_OPTIONS_ID";
export const REQUEST_ABSENCE_NUMBER_ID: string = "REQUEST_ABSENCE_NUMBER_ID";
export const REQUEST_ABSENCE_REPLACEMENT_AGENTS_ID: string =
  "REQUEST_ABSENCE_REPLACEMENT_AGENTS_ID";
export const REQUEST_HOLIDAY_LIST_ID: string = "REQUEST_HOLIDAY_LIST_ID";
export const REQUEST_HOLIDAY_CREATE_ID: string = "REQUEST_HOLIDAY_CREATE_ID";
export const REQUEST_HOLIDAY_UPDATE_ID: string = "REQUEST_HOLIDAY_UPDATE_ID_";
export const REQUEST_HOLIDAY_DELETE_ID: string = "REQUEST_HOLIDAY_DELETE_ID_";

export const REQUEST_QUICK_CHECK_LIST_ID: string = "REQUEST_QUICK_CHECK_LIST_ID";
export const REQUEST_QUICK_CHECK_INDICATOR_ID: string = "REQUEST_QUICK_CHECK_INDICATOR_ID";
export const REQUEST_QUICK_CHECK_UPLOAD_ID: string = "REQUEST_QUICK_CHECK_UPLOAD_ID";
export const REQUEST_QUICK_CHECK_UPDATE_ID: string = "REQUEST_QUICK_CHECK_UPDATE_ID";
export const REQUEST_QUICK_CHECK_DELETE_ID: string = "REQUEST_QUICK_CHECK_DELETE_ID";

export const REQUEST_BANK_SPECIFIC_GET_ID: string = "REQUEST_BANK_SPECIFIC_GET_ID_";
export const REQUEST_BANK_SPECIFIC_OPTIONS_ID: string = "REQUEST_BANK_SPECIFIC_OPTIONS_ID_";
export const REQUEST_BANK_SPECIFIC_AVAILABLE_STATUSES_ID: string =
  "REQUEST_BANK_SPECIFIC_AVAILABLE_STATUSES_ID_";
export const REQUEST_BANK_SPECIFIC_SAVE_ID: string = "REQUEST_BANK_SPECIFIC_SAVE_ID";
export const REQUEST_BANK_SPECIFIC_STATUS_CHANGE_ID: string =
  "REQUEST_BANK_SPECIFIC_STATUS_CHANGE_ID_";
export const REQUEST_BANK_COMMENTS_LIST_ID: string = "REQUEST_BANK_COMMENTS_LIST_ID_";
export const REQUEST_BANK_COMMENT_CREATE_ID: string = "REQUEST_BANK_COMMENT_CREATE_ID";
export const REQUEST_BANK_COMMENT_REPLY_ID: string = "REQUEST_BANK_COMMENT_REPLY_ID";
export const REQUEST_BANK_NOTES_LIST_ID: string = "REQUEST_BANK_NOTES_LIST_ID";
export const REQUEST_BANK_NOTE_CREATE_ID: string = "REQUEST_BANK_NOTE_CREATE_ID";
export const REQUEST_BANK_NOTE_DELETE_ID: string = "REQUEST_BANK_NOTE_DELETE_ID_";
export const REQUEST_BANK_ATTACHMENT_LIST_ID: string = "REQUEST_BANK_ATTACHMENT_LIST_ID";
export const REQUEST_BANK_ATTACHMENT_UPLOAD_ID: string = "REQUEST_BANK_ATTACHMENT_UPLOAD_ID";
export const REQUEST_BANK_ATTACHMENT_DELETE_ID: string = "REQUEST_BANK_ATTACHMENT_DELETE_ID";
export const REQUEST_BANK_ATTACHMENT_SUMMARY_GET_ID: string =
  "REQUEST_BANK_ATTACHMENT_SUMMARY_GET_ID";
export const REQUEST_BANK_ATTACHMENT_SUMMARY_UPLOAD_ID: string =
  "REQUEST_BANK_ATTACHMENT_SUMMARY_UPLOAD_ID";

export const REQUEST_CONTRACT_GET_ID: string = "REQUEST_CONTRACT_GET_ID";
export const REQUEST_CONTRACT_OPTIONS_ID: string = "REQUEST_CONTRACT_OPTIONS_ID";
export const REQUEST_CONTRACT_UPDATE_MULTIPLE_ID: string = "REQUEST_CONTRACT_UPDATE_MULTIPLE_ID";
export const REQUEST_CONTRACT_ATTACHMENT_LIST_ID: string = "REQUEST_CONTRACT_ATTACHMENT_LIST_ID";
export const REQUEST_CONTRACT_ATTACHMENT_UPLOAD_ID: string =
  "REQUEST_CONTRACT_ATTACHMENT_UPLOAD_ID";
export const REQUEST_CONTRACT_ATTACHMENT_DELETE_ID: string =
  "REQUEST_CONTRACT_ATTACHMENT_DELETE_ID";
export const REQUEST_CONTRACT_PAYMENT_LIST_ID: string = "REQUEST_CONTRACT_PAYMENT_LIST_ID_";
export const REQUEST_CONTRACT_PAYMENT_OPTIONS_ID: string = "REQUEST_CONTRACT_PAYMENT_OPTIONS_ID";
export const REQUEST_CONTRACT_PAYMENT_CREATE_ID: string = "REQUEST_CONTRACT_PAYMENT_CREATE_ID";
export const REQUEST_CONTRACT_PAYMENT_DELETE_ID: string = "REQUEST_CONTRACT_PAYMENT_DELETE_ID_";
export const REQUEST_CONTRACT_DOCUMENT_LIST_ID: string = "REQUEST_CONTRACT_DOCUMENT_LIST_ID_";
export const REQUEST_CONTRACT_DOCUMENT_OPTIONS_ID: string = "REQUEST_CONTRACT_DOCUMENT_OPTIONS_ID_";
export const REQUEST_CONTRACT_DOCUMENT_CREATE_ID: string = "REQUEST_CONTRACT_DOCUMENT_CREATE_ID";
export const REQUEST_CONTRACT_DOCUMENT_UPDATE_ID: string = "REQUEST_CONTRACT_DOCUMENT_UPDATE_ID";
export const REQUEST_CONTRACT_DOCUMENT_DELETE_ID: string = "REQUEST_CONTRACT_DOCUMENT_DELETE_ID";
export const REQUEST_CONTRACT_ADJUSTMENT_CREATE_ID: string =
  "REQUEST_CONTRACT_ADJUSTMENT_CREATE_ID";
export const REQUEST_CONTRACT_ADJUSTMENT_LIST_ID: string = "REQUEST_CONTRACT_ADJUSTMENT_LIST_ID_";
export const REQUEST_CONTRACT_ADJUSTMENT_APPROVE_ID: string =
  "REQUEST_CONTRACT_ADJUSTMENT_APPROVE_ID_";
export const REQUEST_CONTRACT_ADJUSTMENT_CANCEL_ID: string =
  "REQUEST_CONTRACT_ADJUSTMENT_CANCEL_ID_";

export const REQUEST_CALL_SCRIPT_TRACK_ID: string = "REQUEST_CALL_SCRIPT_TRACK_ID";

export const REQUEST_KPI_METRICS_ID: string = "REQUEST_KPI_METRICS_ID";
export const REQUEST_KPI_DASHBOARD_ID: string = "REQUEST_KPI_DASHBOARD_ID";
export const REQUEST_KPI_YEARLY_ID: string = "REQUEST_KPI_YEARLY_ID";
export const REQUEST_KPI_TABLE_ID: string = "REQUEST_KPI_TABLE_ID";
export const REQUEST_KPI_SMALL_WINS_ID: string = "REQUEST_KPI_SMALL_WINS_ID";
